module.exports = __webpack_public_path__ + "img/DE03991.20f9e7e8.png";